/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ComponentProvider } from '@angular-kit/view';
import { SharedComponentKey } from './key/shared-component.key';
import { AutoCompleteInputComponent } from './component/auto-complete-input/auto-complete-input.component';
import { MonthSelectComponent } from './component/month-select/month-select.component';

import { SharedInitializer as GlobalInitializer } from '@teamworks/global';
import { CustomTableComponent } from './component/custom-table/custom-table.component';
import { ResizeTextAreaComponent } from './component/resize-text-area/resize-text-area.component';

export class SharedInitializer {

  static initialize() {
    GlobalInitializer.initialize();
    SharedInitializer.registerComponents();
  }

  static registerComponents() {
    ComponentProvider.registerComponentType(SharedComponentKey.AUTO_COMPLETE_INPUT, AutoCompleteInputComponent);
    ComponentProvider.registerComponentType(SharedComponentKey.MONTH_SELECT, MonthSelectComponent);
    ComponentProvider.registerComponentType(SharedComponentKey.CUSTOM_TABLE, CustomTableComponent);
    ComponentProvider.registerComponentType(SharedComponentKey.RESIZE_TEXT_AREA, ResizeTextAreaComponent);
  }

  // static registerLocales() {
  //   LocaleProvider.registerPackageLocale('de', 'shared', {
  //     texts: getJsonExport(texts),
  //     resources: getJsonExport(resources)
  //   });
  // }
}
